import { Grid, Radio } from "@material-ui/core";
import { useState, useEffect } from "react";
import { Bar } from "react-chartjs-2";
import { Button, SelectBox, SVG, Text } from "sunrise-ui";
import FilterComponent from "../../components/helperComponents/FilterComponent";
import "./Reports.scss";
import { useSelector, useDispatch } from "react-redux";
import { AppDispatch } from "../../redux/store";
import {
  Chart as ChartJS,
  Tooltip,
  Legend,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  PointElement,
  LineElement,
  LineController,
} from "chart.js";
import {
  CHART_COLORS,
  customTooltip,
} from "../../constants/reactChartConstants";
import List from "../Machine/List";
import {
  getAllProjectData,
  getItemTypeData,
} from "../../redux/reducers/projectReducers";
import { getAllUserData } from "../../redux/reducers/users";
import {
  getItemConsumptionDetailsData,
  getItemConsumptionReportData,
  reportActions,
} from "../../redux/reducers/reportReducer";
import SelectOptionMsg from "../../utilities/SelectOptionMsg";

ChartJS.register(
  Tooltip,
  Legend,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  PointElement,
  LineElement,
  LineController
);

const ItemConsumptionReport = () => {
  const dispatch = useDispatch<AppDispatch>();
  const allProjectData = useSelector(
    (state: any) => state?.PROJECT?.allProjectData
  );
  const projectNames = allProjectData?.map((project: any) => {
    return project?.projectName;
  });

  const allUserData = useSelector((state: any) => state.USERS.allUserData);

  const consumptionData = useSelector(
    (state: any) => state?.REPORT?.itemConsumptionDetailsData
  );
  const itemTypes = useSelector((state: any) => state?.PROJECT?.itemTypeData);

  const reportData = useSelector(
    (state: any) => state?.REPORT?.itemConsumptionReportData
  );

  const [dataToDownload, setDataToDownload] = useState([]);

  const [projectName, setProjectName] = useState("");
  const [engineerName, setEngineerName] = useState("");
  const [isAscending, setIsAscending] = useState(true);

  const [engineerList, setEngineerList] = useState<any>([]);

  const [projectId, setProjectId] = useState("");
  const [engineerId, setEngineerId] = useState("");
  const [value, setValue] = useState({ from: "", to: "" });

  const [reportProjectName, setReportProjectName] = useState("");
  const [reportItemName, setReportItemName] = useState("");
  const [reportDateValue, setReportDateValue] = useState({ from: "", to: "" });

  const [consumptionTableData, setconsumptionTableData] = useState([]);
  const [consumptionGraphData, setconsumptionGraphData] = useState([]);

  const [unitLabel, setUnitLabel]  = useState("");
  const [engineerNameLabels, setEngineerNameLabels]  = useState<any[]>([]);
  const [engineerData, setEngineerData] = useState<any>([]);

  const handleFilterDate = () => { };
  const resetConsumptionDetailDate = () => {
    setValue({ from: "", to: "" });
  };
  const resetReportDetailDate = () => {
    setReportDateValue({ from: "", to: "" });
  };
  useEffect(()=>{
    setconsumptionTableData([]);
    setconsumptionGraphData([]);
    dispatch(reportActions.resetConsumptionGraphData())
    dispatch(reportActions.resetConsumptionTableData())
  },[dispatch]);
  useEffect(()=>{
    setconsumptionTableData(consumptionData)
  },[consumptionData])

  useEffect(() => {
    // setLoading(true);
    dispatch(getAllUserData({ endPoint: "admin/get-user" })).then((res) => {
      console.log(res);
    });
    dispatch(
      getAllProjectData({
        endPoint: `project/get-all-projects`,
      })
    ).then((res) => {
      console.log(res);
    });
    dispatch(
      getItemTypeData({ endPoint: "master-data/get-master-data?type=items" })
    ).then((res) => {
      console.log(res);
    });
  }, [dispatch]);

  useEffect(()=>{
    const engData = allUserData?.filter((user: any) => {
      return user?.role?.toLowerCase() === "engineer";
    });
    setEngineerData(engData);
  },[allUserData])

  const handleProjectNameChange = (e: any) => {
    setconsumptionTableData([]);
    setEngineerName("")
    setProjectName(e?.target?.value);
    const selectedProject = allProjectData?.filter(
      (project: any) => project?.projectName === e?.target?.value
    );
    setProjectId(selectedProject[0]._id);
    const engineerNames = engineerData?.filter((engineer: any) => {
      const handledProjectPreviously = engineer.projectsHandled.some(
        (project: any) => {
          return project.projectId === selectedProject[0]._id;
        }
      );
      return (
        engineer?.currentProject?.projectId === selectedProject[0]._id ||
        handledProjectPreviously
      );
    });
    setEngineerList(engineerNames.map((engineer: any) => engineer.name));
    resetConsumptionDetailDate()
  };
  const handleEngineerChange = (e: any) => {
    setconsumptionTableData([])
    setEngineerName(e?.target?.value);
    const filteredEngData = engineerData?.filter((engineer: any) => {
      return engineer.name === e?.target?.value;
    });
    setEngineerId(filteredEngData[0]._id);
    resetConsumptionDetailDate();
  };
  const handleSubmit = () => {
    dispatch(
      getItemConsumptionDetailsData({
        endPoint: `admin/get-consumption-details?projectId=${projectId}&engineerId=${engineerId}&fromDate=${value.from}&toDate=${value.to}`,
      })
    ).then((res: any) => {
      console.log(res);
    });
  };


  const handleReportProjectNameChange = (e: any) => {
    setReportProjectName(e?.target?.value);
    setconsumptionGraphData([]);
    setReportItemName("");
    resetReportDetailDate();
  };
  const handleItemTypeChange = (e: any) => {
    setconsumptionGraphData([]);
    setReportItemName(e?.target?.value);
    resetReportDetailDate();
  };
  const handleReportFilterDate = () => { };
  const handleReportSearchSubmit = () => {
    const selectedProjectId = allProjectData?.filter((val: any) => {
      return val?.projectName === reportProjectName;
    })[0]?._id;
    // console.log("selectedProjectId", selectedProjectId);
    dispatch(
      getItemConsumptionReportData({
        endPoint: `admin/get-consumption-report?projectId=${selectedProjectId}&itemName=${reportItemName}&fromDate=${reportDateValue.from}&toDate=${reportDateValue.to}&sorting=${isAscending}`,
      })
    ).then((res: any) => {
      console.log(res);
    });
  };

  const fields = [
    { header: "Item Name", value: "item", search: true },
    { header: "Unit of Item", value: "unit", search: true },
    { header: "Consumed Qty(A)", value: "consumedQty", search: true },
    { header: "Pile Length (B)", value: "pileLength", search: true },
    {
      header: "Avg. Consumption/meter (A/B)",
      value: "avgConsumption",
      search: true,
    },
    { header: "Std Consumption/meter", value: "stdConsumption", search: true },
  ];
 
  useEffect(()=>{
  if(reportData?.length>0){
    const itemUnit = reportData?.filter((val: any) => {
      return val?.unit !== "" && val?.unit !== null && val?.unit !== undefined;
    });
    setUnitLabel(itemUnit?.[0]?.unit);
    setconsumptionGraphData(reportData?.map((val: any) => val?.consumedQty))
  }  
  },[reportData]);
  useEffect(()=>{
    if(engineerData?.length>0 && reportData?.length>0){
      const filteredEngineers = reportData?.flatMap((val: any) => {
        return engineerData?.filter((engineer: any) => {
          return val?.engId === engineer?._id;
        });
      });
      setEngineerNameLabels(filteredEngineers?.map((engineer: any) => engineer?.name));
    }
  },[engineerData, reportData])

  const barChartData2 = {
    labels: engineerNameLabels,
    datasets: [
      {
        label: unitLabel,
        data: consumptionGraphData,
        backgroundColor: [
          CHART_COLORS.BLUE,
          CHART_COLORS.BLUE,
          CHART_COLORS.BLUE,
          CHART_COLORS.BLUE,
        ],
        hoverBackgroundColor: [
          CHART_COLORS.SELECTED_BLUE,
          CHART_COLORS.SELECTED_BLUE,
          CHART_COLORS.SELECTED_BLUE,
          CHART_COLORS.SELECTED_BLUE,
        ],
        barThickness: 20,
      },
    ],
  };
  const multipleEngineerEfficiencyOptions: any = {
    indexAxis: "y",
    plugins: {
      tooltip: customTooltip,
      legend: {
        display: false,
      },
    },
    scales: {
      x: {
        title: {
          display: true,
          text: unitLabel,
          font: { weight: "bold" },
        },
      },
      y: {
        title: { display: true, text: "Engineers", font: { weight: "bold" } },
        grid: { display: false, padding: 5 },
      },
    },
  };
  //-----For Download----------------------------------------------------
  const nullCheck = (item: any) => {
    return item ? item : "";
  };


  useEffect(() => {
    if (consumptionData) {
      const tableData = consumptionData?.map((val: any) => {
        return {
          "Item Name": nullCheck(val?.item),
          "Unit of Item": nullCheck(val?.unit),
          "Consumed Qty(A)": nullCheck(val?.consumedQty),
          "Pile Length (B)": nullCheck(val?.pileLength),
          "Avg. Consumption/meter (A/B)": nullCheck(val?.avgConsumption),
          "Std Consumption/meter": nullCheck(val?.stdConsumption),
        };
      });
      setDataToDownload(tableData)
    }

  }, [consumptionData]);

  return (
    <Grid container className="mt0 pt1">
      <Grid className="standared_width">
        <Text type="normal" fonts="normal" fontSize={18} className="mb0 mt0">
          <span className="fw500">Select Project</span>
        </Text>
        <SelectBox
          data={projectNames}
          value={projectName}
          placeHolder="Select Project"
          defaultVal={""}
          borderColor={"primary"}
          onChange={handleProjectNameChange}
        />
      </Grid>
      <Grid className="standared_width ml-1">
        <Text type="normal" fonts="normal" fontSize={18} className="mb0 mt0">
          <span className="fw500">Select Engineer</span>
        </Text>
        <SelectBox
          data={engineerList}
          value={engineerName}
          placeHolder="Select Engineer"
          defaultVal={""}
          borderColor={"primary"}
          onChange={handleEngineerChange}
        />
      </Grid>
      <Grid item className={"mt0 ml-1"} direction="row" alignItems="center">
        <div className="filter_box_ml mt2">
          <FilterComponent
            handleFilterDate={handleFilterDate}
            setValue={setValue}
            value={value}
            resetAll={resetConsumptionDetailDate}
          />
        </div>
      </Grid>
      <Grid item className="mt2 ml-1">
        <Button
          type="button"
          size="medium"
          isRounded={true}
          category="primary"
          onClick={handleSubmit}
          className="submit_button mt2 mb1 mr-1 pl pr f14"
        >
          <SVG type={"searchIcon"} />
          Search
        </Button>
      </Grid>

      {(consumptionData?.length>0)?<Grid container className="bg--white box--shadow mt1 mb1 plr-1">
        <List
          listData={consumptionTableData}
          fields={fields}
          title={"Item Average Consumption Details"}
          dataToDownload={dataToDownload}
          noBox
        />
      </Grid>:<SelectOptionMsg text="Select  Project, Engineer and Date to view Consumption details" />}

      <Grid container className="bg--white box--shadow mt0 p1">
        <Grid item xs={12} container spacing={2}>
          <Grid item xs={12}>
            <Text
              type="normal"
              fonts="normal"
              fontSize={18}
              className="mb1 mt0"
            >
              <span className="fw500">Average Item Consumption Report</span>
            </Text>
          </Grid>
        </Grid>

        <Grid className="d-flex mb1">
          <Grid className="radio_box">
            <Radio
              checked={isAscending}
              onChange={(e) => {
                //handleStepChange(index, e);
                setIsAscending(true);
              }}
              value="mandatory"
              name="isMandatory"
              inputProps={{ "aria-label": "Mandatory" }}
              color="primary"
            />
            <label>Ascending</label>
            <Radio
              checked={!isAscending}
              onChange={(e) => {
                setIsAscending(false);
              }}
              value="optional"
              name="isMandatory"
              inputProps={{ "aria-label": "Optional" }}
              color="primary"
            />
            <label>Desending</label>
          </Grid>
        </Grid>

        <Grid xs={12} container>
          <Grid item xs={3} className="mr1-imp">
            <Text
              type="normal"
              fonts="normal"
              fontSize={18}
              className="mb0 mt0"
            >
              <span className="fw500">Select Project</span>
            </Text>
            <SelectBox
              data={projectNames}
              value={reportProjectName}
              placeHolder="Select Project"
              defaultVal={""}
              borderColor={"primary"}
              onChange={handleReportProjectNameChange}
            />
          </Grid>
          <Grid item xs={3} className="ml-1">
            <Text
              type="normal"
              fonts="normal"
              fontSize={18}
              className="mb0 mt0"
            >
              <span className="fw500">Select Item</span>
            </Text>
            <SelectBox
              data={itemTypes}
              placeHolder="Select Item"
              value={reportItemName}
              onChange={handleItemTypeChange}
              defaultVal={""}
              borderColor={"primary"}
            />
          </Grid>
          <Grid item className={"ml-1"} direction="row" alignItems="center">
            <div className="filter_box_ml mt2">
              <FilterComponent
                handleFilterDate={handleReportFilterDate}
                setValue={setReportDateValue}
                value={reportDateValue}
                resetAll={resetReportDetailDate}
              />
            </div>
          </Grid>
          <Grid item className="mt2 ml-1">
            <Button
              type="button"
              size="medium"
              isRounded={true}
              category="primary"
              onClick={handleReportSearchSubmit}
              className="submit_button mt2 mb1 mr-1 pl pr f14"
            >
              <SVG type={"searchIcon"} />
              Search
            </Button>
          </Grid>
        </Grid>
        {reportData?.length>0?<Grid item xs={6}>
          <Bar
            data={barChartData2}
            options={multipleEngineerEfficiencyOptions}
          />
        </Grid>:<SelectOptionMsg text="Select Project and Item name and correct Date to view Consumption graph" />}
      </Grid>
    </Grid>
  );
};

export default ItemConsumptionReport;
